/**
* 基础菜单 商品管理
*/
<template>
  <div class="contianer">
    <!-- 面包屑导航 -->
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="">
        <el-input size="small" v-model="formInline.sale_name" placeholder="销售名称" clearable></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="formInline.product_code" placeholder="商品编码" clearable></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-select v-model="formInline.position_type" placeholder="位置名称" clearable>
          <el-option v-for="position in positiontype" :key="position.value"
                     :label="position.name" :value="position.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="">
        <el-select v-model="formInline.status" placeholder="有效类型" clearable>
          <el-option v-for="item in statusList" :key="item.value" :label="item.name"
                     :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="search">查询</el-button>
        <el-button size="small" type="success" @click="addRecommend" class="add-button">新增</el-button>
        <el-button size="small" type="info" @click="editrecommend" class="edit-button">修改</el-button>
        <el-button size="small" type="danger" @click="delProduct">删除</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <div style="height: 530px;overflow-y: auto">
      <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
                @cell-dblclick="cellDbClick" @selection-change="handleSelectionChange"
                :header-cell-style="{background:'#F5F7FA',color:'#666666'}"
                element-loading-text="拼命加载中" style="width: 80%;">
        <el-table-column align="center" type="selection" width="60">
        </el-table-column>
        <el-table-column
          label="序号"
          width="60">
          <template slot-scope="scope">
            {{pageparm.pageSize * (pageparm.currentPage - 1) + (scope.$index + 1)}}
          </template>
        </el-table-column>
        <el-table-column prop="sale_name" label="销售名称" min-width="300" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="product_code" label="商品编码" width="220" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="position_type" label="位置名称" width="120">
          <template slot-scope="scope">
            <div v-if="scope.row.position_type==2290">店铺分类</div>
            <div v-else-if="scope.row.position_type==2291">店铺秒杀</div>
            <div v-else-if="scope.row.position_type==2292">店铺拼团</div>
            <div v-else>未提交</div>
          </template>
        </el-table-column>
        <el-table-column prop="putaway_status" label="上架状态" width="100">
          <template slot-scope="scope">
            <div plain style="color: red;" v-if="scope.row.putaway_status=='76'">下架</div>
            <div plain v-else="scope.row.putaway_status=='75'">上架</div>
          </template>
        </el-table-column>
        <el-table-column prop="create_time" label="创建时间" width="200">
        </el-table-column>
        <el-table-column prop="status" label="状态" width="76">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.status"
              :active-value="1"
              :inactive-value="0"
              @change="changeStatus(scope.row.id,scope.row.status)"
              active-color="#409EFF">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="seq" label="排序号" width="120">
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false"
               :title="dialogTitle"
               :visible.sync="recommendDialogVisible"
               width="32%"
               :before-close="handleClose"
               center>
      <el-form :model="recommendForm" :rules="rules" ref="recommendForm" label-width="165px" class="recommendForm">
        <el-form-item label="位置名称" prop="position_type" class="relative">
          <el-select v-model="recommendForm.position_type" placeholder="请选择位置名称" clearable @change="changeRecommendName(recommendForm.position_type)">
             <el-option v-for="position in positiontype" :key="position.value"
                        :label="position.name"
                        :value="position.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="销售名称" prop="sale_id" class="relative">
          <el-select v-model="recommendForm.sale_id" filterable placeholder="请选择销售名称" clearable
                     remote :filter-method="remoteMethod" class="productInterval" :popper-append-to-body="false"
                     @focus="focusProductName()" @change="changeProductName()" @clear="clear()">
            <el-option :title="item.sale_name" style="width: 320px;"
                       v-for="item in productData"
                       :key="item.sale_id"
                       :label="item.sale_name"
                       :value="item.sale_id">
            </el-option>
            <div class="pagination-absolute">
              <el-pagination :small="small" style="height: 30px;margin-top: 8px"
                             @size-change="productHandleSizeChange"
                             @current-change="productHandleCurrentChange"
                             :current-page.sync="productCurrentPage"
                             :page-size="productPagesize"
                             layout="total, prev, pager, next"
                             :total="productTotalSize">
              </el-pagination>
            </div>
          </el-select>
        </el-form-item>
        <el-form-item label="有效状态" prop="status">
          <el-select v-model="recommendForm.status" placeholder="请选择有效类型" clearable>
            <el-option v-for="item in statusList" :key="item.value" :label="item.name"
                       :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="排序号" prop="seq" class="relative">
          <el-input v-model="recommendForm.seq" auto-complete="off" clearable placeholder="请输入排序号" maxlength="8">
          </el-input>
        </el-form-item>
        <el-form-item label="banner图" prop="banner_img_url" clearable class="list_pic_url" v-if="recommendForm.position_type!=2290">
          <el-upload
            class="avatar-uploader"
            action="#"
            :show-file-list="false"
            :on-remove="handleRemove"
            :http-request="handleUpload"
            :before-upload="beforeUpload">
            <img v-if="form.image" :src="form.image" class="avatar"/>
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <div class="ax_default">
            <span>图片宽度750px，高度最高750px，单张图片大小不得超过1M，仅支持jpg、jpeg、png格式</span>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
            <el-button @click="recommendFirm('recommendForm')">保存</el-button>
            <el-button type="primary" @click="saveSort">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import {
    shopRecommendList,shopRecommendAdd,shopRecommendUpdate,shopRecommendEnabled,shopRecommendDisabled,shopRecommendDetail,productSaleList,productList,shopRecommendDelete
  } from '../../api/basisMG'
  import Pagination from '../../components/Pagination'
  import {getToken, param, upload, uploadImgTmp} from '../../api/commonMG'
  import {uploadFile} from "../../utils/util";

  export default {
    data: () => {
      var validateSeq = (rule, value, callback) => {
        if (value === '' || value == undefined || value == null) {
          return callback(new Error('请输入排序号'));
        } else if (!(/(^[1-9]\d*$)/.test(value))) {
          return callback(new Error('请输入正整数'));
        } else {
          return callback();
        }
      };
      return {
        loading: false, // 显示加载
        isShow: true,
        recommendDialogVisible: false, // 控制页面显示与隐藏
        dialogTitle: '', // 标题
        productId: '',
        selectTableData: [],
        formInline: {
          page: 1,
          rows: 10,
          sale_name: "",
          product_code: "",
          position_type: '',
          status: ''
        },
        recommendForm: {
          id: '',
          sale_id: '',
          position_type: '',
          status: '',
          seq: '',
          banner_img_id: '',
          banner_img_url: '',
        },
        listData: [], //用户数据
        couponlistData:[],
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        sale_id: '',
        // rules表单验证
        rules: {
          position_type: [{required: true, message: '请选择位置名称', trigger: 'change'}],
          sale_id: [{required: true, message: '请选择销售名称', trigger: 'blur'}],
          status: [{required: true, message: '请选择有效类型', trigger: 'change'}],
          seq: [{required: true, validator: validateSeq, trigger: 'blur'}],
          banner_img_url: [{required: true, message: '请选择banner图', trigger: 'blur'}],
        },
        statusList: [{
          name: '有效',
          value: 1
        }, {
          name: '无效',
          value: 0
        }],
        positiontype: [{
          name: '店铺分类',
          value: 2290
        }, {
          name: '店铺秒杀',
          value: 2291
        }, {
          name: '店铺拼团',
          value: 2292
        }],
        form: {
          image: ''
        },
        imgUrl: '',
        productData: [],
        small: true,
        productCurrentPage: 1,
        productPagesize: 10,
        productTotalSize: 0,
        selectedsaleName: '',
        saleName: '',
        isCanSubmit: true,
        ProductBrandList: [],
        productAttrs: [],
      }
    },
    // 注册组件
    components: {
      Pagination
    },
    /**
     * 创建完毕
     */
    created() {
      this.getdata(this.formInline)
    },
    mounted() {
    },
    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
      // 过滤
      Formatter(value, type) {
        if (type == 'VoucherRuleType') {
          for (let item of this.VoucherRuleType) {
            if (item.code == value) {
              if(item.name=='全场通用') {
                return '店铺通用'
              } else {
                return item.name
              }
            }
          }
        }
      },
      //获取系统字典
      getParam(type) {
        param(type)
          .then(res => {
            if (res.success) {
              if (type == 'VoucherRuleType') {
                this.VoucherRuleType = res.content;
              }
            }
          })
          .catch(err => {
          })
      },
      // 获取公司列表
      getdata(parameter) {
        this.loading = true
        shopRecommendList(parameter)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.listData = res.content.rows
              // 分页赋值
              this.pageparm.currentPage = this.formInline.page
              this.pageparm.pageSize = this.formInline.rows
              this.pageparm.total = res.content.total
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.page = parm.currentPage
        this.formInline.rows = parm.pageSize
        this.getdata(this.formInline)
      },
      handleClick(tab, event) {
        console.log(tab, event);
      },
      // 状态
      changeStatus(id, status) {
        if (!status) {
          shopRecommendDisabled(id)
            .then(res => {
              this.loading = false
              if (res.success == false) {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              } else {
                this.$message({
                  type: 'error',
                  message: '已将状态设置为无效!'
                });
                this.getdata(this.formInline)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('网络错误，请稍后再试！')
            })
        } else {
          shopRecommendEnabled(id)
            .then(res => {
              this.loading = false
              if (res.success == false) {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              } else {
                this.$message({
                  type: 'success',
                  message: '已将状态设置为有效!'
                });
                this.getdata(this.formInline)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('网络错误，请稍后再试！')
            })
        }
      },
      // 新增页面推荐
      addRecommend() {
        this.recommendDialogVisible = true;
        this.dialogTitle = '新增页面推荐';
        this.imgUrl = '';
        this.form.image = '';
        this.recommendForm = {
          id: '',
          sale_id: '',
          position_type: '',
          status: '',
          seq: '',
          banner_img_id: '',
          banner_img_url: '',
        };
        this.getProduct();
      },
      getProduct(saleName) {
        let parameter = {
          page: this.productCurrentPage,
          rows: 10,
          keyword: saleName,
          put_away_status: '75',
          sale_type: this.recommendForm.position_type,
        };
        productSaleList(parameter)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              if (!res.rows.length) {
                this.selectedsaleName = ''
              }
              this.productData = res.rows;
              this.productTotalSize = res.total;
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 修改页面推荐
      editrecommend() {
        if (this.selectTableData.length == 0) {
          this.$message.error('请选择一条数据再操作!');
          return
        }
        if (this.selectTableData.length > 1) {
          this.$message.error('当前操作只能选择一条数据!');
          return
        }
        this.productId = this.selectTableData[0].id;
        this.dialogTitle = '修改页面推荐';
        this.recommendDialogVisible = true;
        this.recommendForm.position_type = this.selectTableData[0].position_type;
        this.recommendForm.sale_id = this.selectTableData[0].sale_id;
        this.recommendForm.status = this.selectTableData[0].status;
        this.recommendForm.seq = this.selectTableData[0].seq;
        this.recommendForm.banner_img_url = this.selectTableData[0].banner_img_url;
        this.detail(this.selectTableData[0].id);
         let parameter = {
           page: 1,
           rows: 10,
           saleName: this.selectTableData[0].sale_name,
           productCode: '',
           putaway: '75',
           brandName: ''
         };
         productList(parameter)
           .then(res => {
             this.loading = false
             if (res.success == false) {
               this.$message({
                 type: 'info',
                 message: res.msg
               })
             } else {
               this.selectedsaleName = this.selectTableData[0].sale_name;
               this.productData = res.content.gridData.content;
               this.productTotalSize = res.content.gridData.totalSize
             }
           })
      },
      detail(id) {
        this.loading = true
        shopRecommendDetail(id)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
               if(res.content) {
                 this.form.image = res.content.banner_img_url;
                 this.imgUrl = res.content.banner_img_url;
                 this.recommendForm = res.content;
               }
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      delProduct() {
        if (this.selectTableData.length == 0) {
          this.$message.error('请选择一条数据再操作!');
          return
        }
        if (this.selectTableData.length > 1) {
          this.$message.error('当前操作只能选择一条数据!');
          return
        }
        const title = '是否确认删除页面推荐？';
        this.$confirm(title, '删除页面推荐', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(() => {
          this.loading = true;
          shopRecommendDelete(this.selectTableData[0].id)
            .then(res => {
              this.loading = false
              if (res.success == false) {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              } else {
                this.$message({
                  type: 'success',
                  message: '删除成功!'
                });
                this.getdata(this.formInline)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('网络错误，请稍后再试！')
            })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
      },
      // 保存
      recommendFirm(formName) {
        this.recommendForm.banner_img_url = this.imgUrl;
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.isCanSubmit = false;
            this.loading = true;
            if (this.dialogTitle == '新增页面推荐') {
              shopRecommendAdd(this.recommendForm)
                .then(res => {
                  this.isCanSubmit = true;
                  this.loading = false
                  if (res.success == false) {
                    this.$message({
                      type: 'info',
                      message: res.msg
                    })
                  } else {
                    this.$message({
                      type: 'success',
                      message: '您已成功新增页面推荐'
                    });
                    this.saveSort();
                    this.getdata(this.formInline)
                  }
                })
                .catch(err => {
                  this.isCanSubmit = true;
                  this.loading = false
                  this.$message.error('网络错误,请稍后再试!')
                })
            } else {
              this.recommendForm.banner_img_id = this.productId;
              this.recommendForm.id = this.selectTableData[0].id;
              shopRecommendUpdate(this.recommendForm)
                .then(res => {
                  this.isCanSubmit = true;
                  this.loading = false
                  if (res.success == false) {
                    this.$message({
                      type: 'info',
                      message: res.msg
                    })
                  } else {
                    this.$message({
                      type: 'success',
                      message: '您已成功修改页面推荐'
                    });
                    this.saveSort();
                    this.getdata(this.formInline)
                  }
                })
                .catch(err => {
                  this.isCanSubmit = true;
                  this.loading = false;
                  this.$message.error('网络错误,请稍后再试!')
                })
            }
          } else {
              console.log('error submit!!');
              return false;
            }
        });
      },
      // 搜索事件
      search() {
        this.formInline.page = 1;
        this.getdata(this.formInline)
      },
      handleSelectionChange(val) {
        console.log(val)
        this.selectTableData = val
      },
      handleClose() {
        this.$refs["recommendForm"].resetFields();
        this.recommendDialogVisible = false;
      },
      // 取消按钮
      saveSort() {
        this.recommendDialogVisible = false
      },
      handleRemove(file) {
        console.log(file);
      },
      // 可以获取图片参数
      handleUpload(file) {
        console.log(file)
      },
      beforeUpload(file) {
        const isJPG = file.type === "image/jpeg" || file.type == "image/png";
        const isLt2M = file.size / 1024 / 1024 < 1;
        // if (!isJPG) {
        //   this.$message.error("上传图片仅支持jpg、jpeg、png格式!");
        //   return;
        // }
        if (!isLt2M) {
          this.$message.error("上传图片大小不能超过 1MB!");
          return;
        }
        // 调用[限制图片尺寸]函数
        this.limitFileWH(750, 750, file)
      },
      // 限制图片尺寸
      limitFileWH(E_width, E_height, file) {
        const _this = this
        let imgWidth = ''
        let imgHight = ''
        const isSize = new Promise(function (resolve, reject) {
          const width = E_width
          const height = E_height
          const _URL = window.URL || window.webkitURL
          const img = new Image()
          img.onload = function () {
            imgWidth = img.width
            imgHight = img.height
            const valid = img.width === width && img.height === height
            valid ? resolve() : reject()
          }
          img.src = _URL.createObjectURL(file)
        }).then(() => {
          // const fileData = new FormData();
          // fileData.append("file", file);
          // //upload为上传的接口
          // uploadImgTmp(fileData).then(res => {
          //   this.imgUrl = res.content;
          //   //对返回的图片地址进行回显
          //   this.$set(this.form, "image", res.content);
          // });
          getToken().then(res => {
            if(res) {
              let result = uploadFile(res,file);
              result.then(res => {
                this.imgUrl =  res.data.content.file.fileUrl;
                //对返回的图片地址进行回显
                this.$set(this.form, "image",  res.data.content.file.fileUrl);
              })
            }
          });
          //阻止传到本地浏览器
          return false;
        }, () => {
          _this.$message.error({
            message: '上传图片的尺寸应为' + E_width + '*' + E_height + '，当前上传图片的尺寸为：' + imgWidth + '*' + imgHight,
            btn: false
          })
          return false
        })
        return isSize
      },
      remoteMethod(val) {
        this.productCurrentPage = 1
        this.saleName = val;
        this.getProduct(val)
      },
      focusProductName() {
        if (!this.selectedsaleName) {
          this.saleName = ''
          this.getProduct('')
        }
      },
      clear() {
        this.getProduct()
        this.productCurrentPage = 1
        this.saleName = ''
      },
      changeProductName() {
        this.productCurrentPage = 1
        this.productData.forEach((item) => {
          if (item.sale_id == this.recommendForm.sale_id) {
            this.selectedsaleName = item.sale_name;
            this.getProduct(item.sale_name)
          }
        })
      },
      changeRecommendName(position_type, sale_id, type) {
        this.$set(this.recommendForm, "sale_id", "");
        // if (type != 'editSort') {
        //   this.$refs["recommendForm"].clearValidate(['sale_id']);
        // }
        this.getProduct()
      },
      productHandleSizeChange(val) {
        //console.log(`每页 ${val} 条`);
        this.productPagesize = val;
        this.getProduct(this.saleName)
      },
      productHandleCurrentChange(val) {
        //console.log(`当前页: ${val}`);
        this.productCurrentPage = val;
        this.getProduct(this.saleName)
      },
      // 分页插件事件
      productCallFather() {
        this.getProduct(this.formInline)
      },
      //双击复制
      cellDbClick(row, column, cell, event) {
        if (row.sale_name == cell.innerText || row.product_code == cell.innerText || row.position_type == cell.innerText) {
          if (event.type === "dblclick") {
            var save = function (e) {
              e.clipboardData.setData('text/plain', cell.innerText);
              e.preventDefault();//阻止默认行为
            }
            document.addEventListener('copy', save);
            document.execCommand("copy");
            document.removeEventListener('copy', save);
          }
          this.$message({message: '复制成功', type: 'success'})
        }
      }
    }
  }
</script>

<style scoped>
  .contianer {
    background: #fff;
    padding: 20px;
  }

  /deep/ .user-search .el-input__inner {
    height: 40px;
    line-height: 40px;
  }

  /deep/ .user-search .el-form-item {
    margin-bottom: 10px;
  }

  /deep/ .user-search .el-button--small {
    height: 40px;
  }

  /deep/ .el-dialog--center {
    border-radius: 8px !important;
  }

  /deep/ .recommendForm .el-input__inner {
    height: 40px;
    line-height: 40px;
    width: 320px;
  }

  /deep/ .recommendForm .el-input {
    width: 320px;
  }

  /deep/ .recommendForm .el-input--small {
    width: 320px;
  }

  /deep/ .sortForm .el-input__inner {
    height: 40px;
    line-height: 40px;
    width: 320px;
  }

  /deep/ .sortForm .el-input {
    width: 320px;
  }

  /deep/ .sortForm .el-input--small {
    width: 320px;
  }

  /deep/ .brandForm .el-input__inner {
    height: 40px;
    line-height: 40px;
    width: 320px;
  }

  /deep/ .brandForm .el-input {
    width: 320px;
  }

  /deep/ .brandForm .el-input--small {
    width: 320px;
  }

  /deep/ .el-message-box__title {
    color: #409EFF !important;
  }

  /deep/ .el-dialog__title {
    color: #409EFF !important;
  }

  .add-button {
    background: #53B03C;
    border-color: #53B03C;
  }

  .edit-button {
    background: #58B7D6;
    border-color: #58B7D6;
  }

  .breadcrumb {
    margin-bottom: 15px;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 320px;
    height: 150px;
    line-height: 150px;
    text-align: center;
    border: 1px dashed #DCDFE6;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar {
    width: 320px;
    height: 150px;
    display: block;
    border: 1px solid #ccc;
    border-radius: 5px;
  }

  .avatar-uploader {
    height: 150px;
  }

  .ax_default {
      border-width: 0px;
      width: 280px;
      display: flex;
      font-size: 11px;
      color: #D9001B;
      text-align: left;
      line-height: 20px;
      margin: 20px 0 0 0;
  }

  .pagination-absolute {
      position: absolute;
      bottom: 0;
      background: #fff;
      width: 94%;
      padding-left: 20px;
      height: 40px;
  }

  /deep/ .recommendForm .el-select-dropdown__list {
    padding-bottom: 50px;
    min-height: 150px;
  }

</style>





// WEBPACK FOOTER //
// src/views/goods/Goodmend.vue